import Payment from 'components/payment/payment.component';
import { useOrderPayment } from 'components/payment/payment.new.hooks';
import CheckoutSections from '../checkout-sections/checkout-sections.component';
import { selectPaymentInstrumentId } from 'redux/cart/cart.selectors';
import { useSelector } from 'react-redux';

const CheckoutPaymentWrapper = () => {
  const newPaymentContext = useOrderPayment();

  const paymentInstrumentId = useSelector(selectPaymentInstrumentId);

  return (
    <Payment
      value={newPaymentContext}
      paymentInstrumentId={paymentInstrumentId}
    >
      <CheckoutSections />
    </Payment>
  );
};
export default CheckoutPaymentWrapper;
